import styled, { css } from 'styled-components';

export const Cell = styled.td`
  &:nth-child(2) {
    width: 180px;
    max-width: 180px;
    word-break: break-word;
  }

  &:nth-child(3) {
    width: 270px;
    max-width: 270px;
  }

  &:nth-child(4) {
    width: 220px;
    max-width: 220px;
  }

  &:nth-child(5) {
    width: 100px;
    max-width: 100px;
  }

  &:nth-child(3),
  &:nth-child(4),
  &:nth-child(6) {
    word-break: break-all;
  }

  [data-theme='MozartSelectField'] {
    width: 100%;
  }
`;

export const Header = styled.th``;

export const Row = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #d9d5f9;
  }

  ${Header}, ${Cell} {
    font-weight: 400;
    padding: 15px 10px;
  }

  ${(props) =>
    props.mismatch &&
    css`
      ${Cell} {
        background-color: #fbeae9 !important;
      }
    `}
`;

export const Body = styled.tbody`
  ${Row}:nth-child(2n) ${Cell} {
    background-color: #f5f4fe;
  }
`;

export const Head = styled.thead`
  ${Row} ${Header} {
    background-color: #f5f4fe;
  }
`;

export const Table = styled.table`
  color: #3e3a83;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  width: 100%;
  border-collapse: collapse;

  ${Head}, ${Body} {
    ${Row}:last-child {
    }
  }
`;
